import React from 'react';
import { useAssignDeliveryMutation } from '../../store/slices/apiSlice';
import { useToast } from '../../hooks/useToast';

interface InlineDeliveryUserEditorProps {
  job: any;
  deliveryUsers: any[]; // Pass from parent to avoid extra API call
  onUpdated: () => void;
  selectedUsername?: string; // Username from filter
}

export const InlineDeliveryUserEditor: React.FC<InlineDeliveryUserEditorProps> = ({
  job,
  deliveryUsers,
  onUpdated,
  selectedUsername = '',
}) => {
  const [assignDelivery, { isLoading }] = useAssignDeliveryMutation();
  const toast = useToast();

  // Use the selected username from filter (all jobs have this engineer assigned)
  const currentUsername = selectedUsername;

  const handleUserChange = async (newUsername: string) => {
    if (!newUsername || newUsername === currentUsername) {
      return;
    }

    const newUser = deliveryUsers.find((u: any) => u.username === newUsername);
    if (!newUser) {
      return;
    }

    try {
      await assignDelivery({
        id: job.id,
        data: { 
          delivery_user: parseInt(newUser.id),
          potential_delivery_date: job.potential_delivery_date
        },
      }).unwrap();

      toast.success(`Job #${job.website_job_number} assigned to ${newUser.username}`);
      onUpdated();
    } catch (error: any) {
      toast.error(error?.data?.detail || 'Failed to update engineer');
    }
  };

  return (
    <select
      value={currentUsername}
      onChange={(e) => handleUserChange(e.target.value)}
      disabled={isLoading}
      className="text-sm border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-blue-500 w-full"
    >
      <option value="">Select engineer...</option>
      {deliveryUsers.map((user: any) => (
        <option key={user.id} value={user.username}>
          {user.username}
        </option>
      ))}
    </select>
  );
};
